export const Role = {
    Client: 1,
    Translator: 2,
    TranslatorVIP: 4
}